import LotteryNumlotDetailContainer from "../../components/lottery/containers/LotteryNumlotDetailContainer";
import LotteryNumlotDetailTemplate from "../../components/lottery/templates/LotteryNumlotDetailTemplate";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function Numbers3() {
  return (
    <>
      <LotteryLocalNav placement="mainHeader" lotteryKey="nm3" />
      <section className="min-h-screen">
        <LotteryNumlotDetailContainer lotteryKey="nm3" Template={LotteryNumlotDetailTemplate} />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="nm3" />
    </>
  );
}
export default Numbers3;
